module.exports = __webpack_public_path__ + "img/p5.4e29187f.jpg";